import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import Modal from '@/assets/common/Modal/Modal.vue';
import { AgriFieldList } from '@/types';
import { AgriFieldGroupDetail } from '@/types/Component';
import { AgriFieldGroupResponse } from '@/types/APIResponse';

const initAgriFieldGroup: AgriFieldGroupDetail = {
    id: null,
    name: '',
    agriFields: []
}

@Component({
    components: {
        Modal,
        Multiselect,
    }
})
export default class AgriFieldGroupModal extends Vue {
    private modalTitle = '圃場グループ新規作成'

    private agriFieldGroup: AgriFieldGroupDetail = initAgriFieldGroup
    private agriFields: AgriFieldList[] = []

    private isLoading = true

    @Prop()
    private value!: boolean

    @Prop({ default: null })
    private groupId!: string

    @Watch('showAgriFieldGroupModal')
    private async onChangeShowAgriFieldGroupModal() {
        this.isLoading = true

        if (this.showAgriFieldGroupModal) {
            this.modalTitle = '圃場グループ新規作成'
            this.agriFieldGroup = {
                id: null,
                name: '',
                agriFields: []
            }
            this.agriFields = await this.getFields()
            if (this.groupId !== null) {
                const group = await this.getGroup(this.groupId)
                this.agriFieldGroup = {
                    id: null,
                    name: group.name,
                    agriFields: this.agriFields.filter(af => group.agri_fields.includes(af.id)),
                }
                this.modalTitle = '圃場グループ編集'
            }
        }

        this.isLoading = false
    }

    get showAgriFieldGroupModal(): boolean {
        return this.value
    }

    set showAgriFieldGroupModal(value: boolean) {
        this.value
    }

    get isValid(): boolean {
        const nameValid = !!this.agriFieldGroup.name
        const agriFieldsValid = this.agriFieldGroup.agriFields.length > 0
        return nameValid && agriFieldsValid
    }

    private success(word: '保存' | '削除') {
        this.$toasted.success(`${word}しました。`)
        return true
    }

    private error(word: '保存' | '削除') {
        this.$toasted.error(`${word}に失敗しました。`)
        return false
    }

    @Emit('save')
    async save(): Promise<boolean> {
        // 名前の長さチェック
        if(this.agriFieldGroup.name.length > 100) {
            window.alert(`圃場グループ名は100文字以内で入力してください（現在は${this.agriFieldGroup.name.length}文字）`)
            return false
        }
        const reqData: AgriFieldGroupResponse = {
            name: this.agriFieldGroup.name,
            agri_fields: this.agriFieldGroup.agriFields.map(af => af.id),
        }
        if (this.groupId === null) {
            const close = await this.$apiClient.doRequest('post', '/admin/agri_field_groups/', reqData)
                .then(() => this.success('保存'))
                .catch(() => this.error('保存'))

            if(close) {
                this.agriFieldGroup = initAgriFieldGroup
            }
            return close
        }
        else {
            const close = await this.$apiClient.doRequest('put', `/admin/agri_field_groups/${this.groupId}`, reqData)
                .then(() => this.success('保存'))
                .catch(() => this.error('保存'))

            if(close) {
                this.agriFieldGroup = initAgriFieldGroup
            }
            return close
        }
    }

    @Emit('cancel')
    cancel(): boolean {
        this.agriFieldGroup = initAgriFieldGroup
        return true
    }

    @Emit('delete')
    async del(): Promise<boolean> {
        const confirm = window.confirm('削除しますか？')
        if (confirm) {
            return await this.$apiClient.doRequest('delete', `/admin/agri_field_groups/${this.groupId}`)
                .then(() => this.success('削除'))
                .catch(() => this.error('削除'))
        }
        else {
            this.$toasted.success('削除がキャンセルされました。')
            return false
        }
    }

    private async getGroup(id: string) {
        const group = await this.$apiClient.doRequest('get', `/admin/agri_field_groups/${id}`)
        return group
    }

    private async getFields(): Promise<AgriFieldList[]> {
        const res = await this.$apiClient.doRequest('get', '/agri_fields')
        return res.agri_fields
    }
}
